/** bookings_type id for FCL (full container load). */
export const FCL_BOOKING_TYPE_ID = 2;

export const SERVICE_LEVEL_VALUES = ["budget", "premium"] as const;

export type ServiceLevel = (typeof SERVICE_LEVEL_VALUES)[number];

export const SERVICE_LEVEL_TRANSLATION_KEYS: Record<ServiceLevel, string> = {
  budget: "bookingWizard.transportDetails.serviceLevelBudget",
  premium: "bookingWizard.transportDetails.serviceLevelPremium",
};

export const SERVICE_LEVEL_LABELS: Record<ServiceLevel, string> = {
  budget: "Budget",
  premium: "Premium",
};

export function isServiceLevel(value: unknown): value is ServiceLevel {
  return (
    typeof value === "string" &&
    SERVICE_LEVEL_VALUES.includes(value as ServiceLevel)
  );
}

export function isFclBookingType(bookingTypeId: number | null | undefined): boolean {
  return bookingTypeId === FCL_BOOKING_TYPE_ID;
}
